import { FetchProps } from 'src/Libs/shop/hooks/use-shop-fetch'
import { AxiosResponse } from 'axios'
import { PhonePrefix } from '../utils'
import { SHOP_AVIS_SHIPPING_METHOD_ID, SHOP_QNTM_SELF_PICK_SHIPPING_METHOD_ID } from '../consts'

export type ShopAuthFetchWithResponse = <T>(props: FetchProps) => Promise<AxiosResponse<T>>

export enum MoreInfoModalTabs {
  DESCRIPTION = 1,
  TECHNICHAL_INFORMATION = 2,
  DOWNLOADS = 3,
}

export enum ProgressBarSteps {
  BasicSystem = 1,
  MainComponent = 2,
  AdditionalComponent = 3,
}

export enum PowerMeterLimits {
  /* The id for External Soruce Starts from ID101 */
  IdWithoutNumber = 'ID10',
  ExternalSourceMinId = 'ID101',
  ExternalSourceMaxId = 'ID104',
  FarmingId = 'ID105',
  HouseConnectionId = 'ID106',
}

export enum PowerMeterQuestionTypes {
  None = 'NotSelected',
  ExternalSource = 'ExternalSource',
  Farming = 'Farming',
  HouseConnection = 'HouseConnection',
}

export enum PowerMeterQuestionOptions {
  None = 'NotSelected',
  WithEthernet = 'withEthernet',
  WithoutEthernet = 'withoutEthernet',
  Other = 'other',
}

export enum PowerMeterTypes {
  WithEthernet = 'withEthernet',
  WithoutEthernet = 'withoutEthernet',
  Other = 'other',
}

export enum PowerMeterTabs {
  TypesTab = 1,
  OptionsTab = 2,
}

export enum ProductType {
  SystemBase = 'SYSTEM_BASE',
  PowerMeter = 'POWER_METER',
  SmartMeter = 'SMART_METER',
  RetrofitBattery = 'RETROFIT_BATTERY',
  Normal = 'NORMAL',
  QntmProduct = 'EM360',
}

export const ShippingMethod = {
  Avis: SHOP_AVIS_SHIPPING_METHOD_ID,
  QntmSelfPick: SHOP_QNTM_SELF_PICK_SHIPPING_METHOD_ID,
} as const

export interface ShippingFormType {
  shippingMethod: string
  contactPerson: string
  phonePrefix: PhonePrefix
  phoneNumber: string
  comment: string
}

export enum SystemConfigureType {
  NormalSystem = 'system',
  Favorite = 'fav-system',
  QntmSystem = 'qntm-system',
}

export enum TransformerType {
  SystemConfigure = 'System-Configure',
  SingleProduct = 'Single-Product',
}

export enum CategoryType {
  SystemConfigurationName = 'systemConfigurator',
  FavoriteSystemConfigurationName = 'savedConfigurations',
  QntmSystemConfiguratioName = 'quantumSystemConfigurator',
}

export enum HistoryStatusId {
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Inplanning = 'INPLANNING',
  Open = 'OPEN',
  PartialDelivered = 'PARTIALDELIVERED',
  PartialDeliveryPlanned = 'PARTIALDELIVERYPLANNED',
}

export enum ShopImageThumnbailSizes {
  ExtraSmall = 100,
  Small = 260,
  Medium = 452,
  Large = 600,
  Banner = 2600,
  Category = 1200,
  Product = 1920,
}

export enum ShopQuantityAvailableTypes {
  Available = 'green',
  OutOfStock = 'red',
  FewLeft = 'yellow',
}

export enum ShopSystemConfigurationTypes {
  Fix = 'FIX',
  Flex = 'FLEX',
}

export enum ShopProductPageTypes {
  Search = 'search',
}

export enum ProductGeneralType {
  SYSTEM_CONFIGURATOR = 'configured_system',
  QNTM_SYSTEM_CONFIGURATOR = 'quantum_configured_system',
  PRODUCT = 'product',
  PROMOTION = 'promotion',
}

export enum ShopMediaType {
  Image = 'image',
  Application = 'application',
}

export enum DayOfWeek {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 0,
}
